
export const leftPanelZIndices = {
  countrySelector: 20,
  text: 10,
};
